import { Factory } from '../Factory';

export class ProcessingService implements IService {
  private httpService: any;
  private configService: any;
  private notificationService: any;

  constructor(httpService, configService, notificationService) {
    this.httpService = httpService;
    this.configService = configService;
    this.notificationService = notificationService;
  }

  public ProcessData(collection, originalSourceStorage: any, file: any, progressCallback: Function, successCallback: Function, errorCallback: Function) {
    const source = {...originalSourceStorage};
    delete source.files;
    delete source.getListings;

    let url = `${this.configService.getServerBaseUrl()}/project/${collection.projectId}/collection/${collection.id}/process?${$.param(source)}`;
    let formData = new FormData();

    if (file) {
      formData.append("file", file);
    }

    progressCallback(0, 0, 0);

    this.httpService.$ajax(url, {
      type: "POST",
      data: formData,
      cache: false,
      processData: false,
      contentType: false,
      xhr: () => {
        let myXhr = $.ajaxSettings.xhr();
        if (myXhr.upload) {
          myXhr.upload.addEventListener("progress", (ev: any) => {
            if (ev.lengthComputable) {
              let percentUploaded = Math.floor(ev.loaded * 100 / ev.total);
              progressCallback(ev.loaded, ev.total, percentUploaded);
            }
          }, false);
        }
        return myXhr;
      },
      success: successCallback,
      error: errorCallback
    });
  }

  public ResumeProcessing(collection, successCallback: Function, errorCallback: Function) {
    let url = `${this.configService.getServerBaseUrl()}/project/${collection.projectId}/collection/${collection.id}/process/resume`;

    this.httpService.$ajax(url, {
      type: "POST",
      cache: false,
      processData: false,
      contentType: false,
      success: successCallback,
      error: errorCallback
    });
  }

  public VerifyIMAPCredentials(collection, originalSourceStorage: any, successCallback: Function, errorCallback: Function) {
    let url = `${this.configService.getServerBaseUrl()}/project/${collection.projectId}/imap/credentials/verify`;

    this.httpService.$ajax(url, {
      type: "POST",
      data: JSON.stringify({source: originalSourceStorage}),
      cache: false,
      processData: false,
      contentType: "application/json; charset=utf-8",
      success: successCallback,
      error: errorCallback
    });
  }

  public ValidateForensicImage(projectId, originalSourceStorage: any, collection: any) {
    const source = {...originalSourceStorage};
    delete source.files;
    delete source.getListings;

    let url = `${this.configService.getServerBaseUrl()}/project/${projectId}/validateForensicImage?${$.param(source)}`;

    this.httpService.$ajax(url, {
      type: "POST",
      data: JSON.stringify(collection),
      cache: false,
      processData: false,
      contentType: "application/json; charset=utf-8",
    });
  }
}

frontendApp.factory("ProcessingService", ["HttpService", "ConfigService", "NotificationService", Factory.Create(ProcessingService)]);
